import axiosInstance from "services/common/axiosInstance";

const handleRequest = async (promise: Promise<any>) => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error.message;
  }
};

const BASE_URL = "/dscashdeliv";

export const getAllDoorstepDeliveryRequestAdmin = (data: any) =>
  handleRequest(
    axiosInstance.post(
      `${BASE_URL}/getalldoorstepdeliveryrequest_admin`,
      data
    )
  );

export const addDeliveryCharge = (data: any) =>
  handleRequest(axiosInstance.post(`${BASE_URL}/adddeliverycharge`, data));

export const getAllDeliveryCharge = () =>
  handleRequest(axiosInstance.get(`${BASE_URL}/getalldeliverycharge`));

export const updateDeliveryCharge = (chargeId: number, data: any) =>
  handleRequest(
    axiosInstance.put(`${BASE_URL}/updatedeliverycharge`, data, {
      params: { charge_id: chargeId },
    })
  );

export const changeDeliveryChargeStatus = (chargeId: number, data: any) =>
  handleRequest(
    axiosInstance.put(`${BASE_URL}/changedeliverychargestatus`, data, {
      params: { charge_id: chargeId },
    })
  );

export const deleteDeliveryCharge = (chargeId: number, data: any) =>
  handleRequest(
    axiosInstance.delete(`${BASE_URL}/deletedeliverychange`, {
      params: { charge_id: chargeId },
      data,
    })
  );

